module.exports = __webpack_public_path__ + "static/img/yeswecan0016.9eba0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0016.png
// module id = 591
// module chunks = 1